module.exports = require('./helpers/bundle-url').getBundleURL('3eKgh') + "logo.c51670a8.svg";